export type FileNamingTemplateEntry = {
  is_firm_override: boolean;
  origin?: string | null;
  template_string?: string | null;
};

/**
 * True when the firm has never saved a file naming template and is still on
 * system defaults. Scans the full templates array — a per-doc-type save still
 * counts even if `__all__` has `is_firm_override: false`.
 */
export const isFirmOnDefaultNamingTemplates = (
  templates: FileNamingTemplateEntry[] | undefined | null,
): boolean => {
  if (!templates?.length) return false;
  return !templates.some((t) => t.is_firm_override === true);
};
